import { getProductFormField } from '../utils';
import Component from './ProductFormRadioSelect';
import { injectIntl } from 'react-intl';

export default getProductFormField(injectIntl(Component));
